import type { Device, DomainEvent, Journey, JourneyDraftPatch, PushSubscriptionInput } from '@reisepilot/contracts'
import { http, uploadFile } from './client'
import type {
  DeviceCreatedResponse,
  DeviceLocation,
  DeviceTokenResponse,
  DocumentResponse,
  JourneyDetail,
  JourneyStatusResponse,
  MeResponse,
} from './types'

export const api = {
  login: (password: string): Promise<void> => http.post<void>('/auth/login', { password }),
  logout: (): Promise<void> => http.post<void>('/auth/logout'),
  me: (): Promise<MeResponse> => http.get<MeResponse>('/me'),

  uploadDocument: (file: File, onProgress?: (percent: number) => void): Promise<DocumentResponse> =>
    uploadFile<DocumentResponse>('/documents', file, onProgress),
  document: (id: string): Promise<DocumentResponse> => http.get<DocumentResponse>(`/documents/${id}`),
  retryExtraction: (id: string): Promise<DocumentResponse> =>
    http.post<DocumentResponse>(`/documents/${id}/retry-extraction`),

  journeys: (): Promise<Journey[]> => http.get<Journey[]>('/journeys'),
  journey: (id: string): Promise<JourneyDetail> => http.get<JourneyDetail>(`/journeys/${id}`),
  patchJourney: (id: string, patch: JourneyDraftPatch): Promise<JourneyDetail> =>
    http.patch<JourneyDetail>(`/journeys/${id}`, patch),
  resolveJourney: (id: string): Promise<JourneyDetail> => http.post<JourneyDetail>(`/journeys/${id}/resolve`),
  confirmJourney: (id: string): Promise<JourneyDetail> => http.post<JourneyDetail>(`/journeys/${id}/confirm`),
  cancelJourney: (id: string): Promise<JourneyDetail> => http.post<JourneyDetail>(`/journeys/${id}/cancel`),
  deleteJourney: (id: string): Promise<void> => http.delete<void>(`/journeys/${id}`),
  journeyEvents: (id: string): Promise<DomainEvent[]> => http.get<DomainEvent[]>(`/journeys/${id}/events`),
  journeyStatus: (id: string): Promise<JourneyStatusResponse> =>
    http.get<JourneyStatusResponse>(`/journeys/${id}/status`),

  devices: (): Promise<Device[]> => http.get<Device[]>('/devices'),
  deviceLocations: (): Promise<DeviceLocation[]> => http.get<DeviceLocation[]>('/devices/locations'),
  createDevice: (name: string): Promise<DeviceCreatedResponse> =>
    http.post<DeviceCreatedResponse>('/devices', { name }),
  rotateDeviceToken: (id: string): Promise<DeviceTokenResponse> =>
    http.post<DeviceTokenResponse>(`/devices/${id}/rotate-token`),
  revokeDevice: (id: string): Promise<Device> => http.post<Device>(`/devices/${id}/revoke`),
  deleteDevice: (id: string): Promise<void> => http.delete<void>(`/devices/${id}`),

  subscribePush: (input: PushSubscriptionInput): Promise<void> => http.post<void>('/push/subscriptions', input),
  unsubscribePush: (endpoint: string): Promise<void> => http.delete<void>('/push/subscriptions', { endpoint }),
  testPush: (): Promise<void> => http.post<void>('/push/test'),
}
